import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Birim } from '../models/birim.model';
import { Kategori } from '../models/kategori.model';
import { KullaniciTalep } from '../models/kullaniciTalep.model';
import { NebisTalepBilgiler } from '../models/nebisTalep.model';
import { Response } from '../models/response.model';


@Injectable({
  providedIn: 'root'
})
export class KullaniciTalepService {
  apiUrl = '/api/talep'
  constructor(private http: HttpClient) {
  }


  // getAll(query: string = '', page: number = 1, rowCount: number = 10): Observable<Response<KullaniciTalep[]>> {
  //   return this.http.get<Response<KullaniciTalep[]>>(this.apiUrl + '/getList', {
  //     params: {
  //       'aramastr': query,
  //       'sayfasayisi': page,
  //       'sayfadakisatirsayisi': rowCount
  //     }
  //   });
  // }


  getAll(query: string = '', page: number = 1, rowCount: number = 10): Observable<Response<NebisTalepBilgiler[]>> {
    return this.http.get<Response<NebisTalepBilgiler[]>>(this.apiUrl + '/nebisTalepList', {
      params: {
        'aramastr': query,
        'sayfasayisi': page,
        'sayfadakisatirsayisi': rowCount
      }
    });
    
  }

  getBirimList(): Observable<Response<Birim[]>> {
    return this.http.get<Response<Birim[]>>(this.apiUrl + '/birimList');
  }

  getKategoriList(): Observable<Response<Kategori[]>> {
    return this.http.get<Response<Kategori[]>>(this.apiUrl + '/kategoriList');
  }



  getById(id: number): Observable<Response<KullaniciTalep>> {
    return this.http.get<Response<KullaniciTalep>>(this.apiUrl + '/getbyid?id=' + id);
  }


  nebisAktifTalepList(): Observable<Response<NebisTalepBilgiler[]>> {
    return this.http.get<Response<NebisTalepBilgiler[]>>(this.apiUrl + '/nebisAktifTalepList');
  }


  getNebisById(id: number): Observable<Response<NebisTalepBilgiler>> {
    return this.http.get<Response<NebisTalepBilgiler>>(this.apiUrl + '/getnebisbyid?TalepID=' + id);
  }

  // delete(id:number):Observable<Response<KullaniciTalep>>{
  //   return this.http.post<Response<KullaniciTalep>>(this.apiUrl+"/delete?id="+id,{})
  // }

  delete(kullaniciTalep: NebisTalepBilgiler): Observable<Response<NebisTalepBilgiler>> {
    return this.http.post<Response<NebisTalepBilgiler>>(this.apiUrl + '/delete', kullaniciTalep)
  }


  dosyaYukle(formData: FormData): Observable<Response<any>> {
    return this.http.post<Response<any>>(this.apiUrl + "/fileAdd", formData)
  }


  dosyaSil(dosyaUrl: string): Observable<Response<any>> {
    return this.http.post<Response<any>>(this.apiUrl + "/fileDelete/?dosyaUrl="+dosyaUrl,{})
  }

  dosyaIndirNebis(talepID: number, hareketID: number):Observable<any> {
    return this.http.get<any>(this.apiUrl + "/fileDownload/?TalepID="+talepID+"&HareketID="+hareketID )
  }

  //------- dosyaBilgi(dosyaUrl: string):Observable<Response<string>> {
  //   return this.http.get<Response<string>>(this.apiUrl + "/dosyaBil/?dataFile="+dosyaUrl)
  //------ }

  dosyaBilgi(dosyaUrl: string):Observable<Response<any>> {
    return this.http.get<Response<any>>(this.apiUrl + "/dosyaBil/?dataFile="+dosyaUrl)
  }

  addUpdate(kullaniciTalep: KullaniciTalep): Observable<Response<KullaniciTalep>> {
    //  let headers = new HttpHeaders();
    //  headers = headers.append("Content-Type", "application/json");
    //  headers = headers.append("Content-Type", "multipart/form-data");

    if (kullaniciTalep.id > 0) {
      return this.http.post<Response<KullaniciTalep>>(this.apiUrl + "/update", kullaniciTalep)
    }
    else {
      return this.http.post<Response<KullaniciTalep>>(this.apiUrl + "/add", kullaniciTalep)
    }
  }

}
